import { Injectable } from '@angular/core';
import {
  assistanceDetailNavItems, beitragszahlerDetailNavItems, betreuerdatenadminNavItems, betreuerDetailNavItems, betreuerknotenDetailNavItems, bezugsberechtigterDetailNavItems, buchungsNavItems, cmsNavItems, fahrzeugDetailNavItems, familienpassDetailNavItems, gebaeudeDetailNavItems, haushaltDetailNavItems, hotlineDetailNavItems, kundenAdminNavItems, maklerDLNavItems, maklerpersonDetailNavItems, maklerpolizzeDetailNavItems, maklerschadenDetailNavItems, maklervertreterDetailNavItems, partnerDetailNavItems, personDetailLocked, personDetailNavItems, polDetailAchtungNavItem, polDetailFFNavItem, polDetailGenehmigungenNavItem, polDetailLebentNavItem, polDetailLocked, polDetailNavItems, polDetailRabattkontoNavItem, polDetailRendementNavItem, polDetailTexteNavItem, polDFZNavItem, polFamilienpassItem, polFondPlusNavItem, positionsNavItems, referatAdminNavItems, schadenbeteiligterDetailNavItems, schadenDeckungsbedenken, schadenDetailLocked, schadenDetailNavItems, schadenzahlungempfDetailNavItems, textDetailNavItems, ungeklaerteZahlungenArchivDetailNavItems, userAdminDetailNavItems, verbundDetailNavItems, versichertepersonDetailNavItems, vertragNavItems, vertreterDetailNavItems, vsbDetailNavItems, zahlungsNavItems, zulassungDetailNavItems, zulassungKennzeichenNavItems
} from '@app/shared/global-sidenav/global-sidenav.items';
import { Navitem, SubItemCategory } from '@app/shell/navitems';
import { Betreuer, Person, Polizze, PolizzeBuchungDetail, Position, Schaden, Schadenbeteiligung, Textbaustein, Vertrag, Vertreter, ZulassungResult } from '@pezi/entities';
import { PolizzeOpostenArchivUngeklaerteZahlungen } from '@pezi/entities/dist/src/main/ts/models/generated/polizze/polizzeopostenarchivungeklaertezahlungen';

@Injectable()
export class GlobalSidenavUtil {

  public static getPoliceSidenav(police: Polizze): SubItemCategory[] {
    const additonalItems: Navitem[] = [];
    let navItems: Navitem[] = [];
    if (police.locked) {
      additonalItems.push(polDetailLocked('/polizze/' + police.id.toString()));
    } else {
      navItems = polDetailNavItems('/polizze/' + police.id.toString());
      if (police.tabs && police.tabs.achtung) {
        additonalItems.push(polDetailAchtungNavItem('/polizze/' + police.id.toString()));
      }
      if (police.ffPolNr) {
        additonalItems.push(polDetailFFNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.zusaetzlicheTexte) {
        additonalItems.push(polDetailTexteNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.rendement) {
        additonalItems.push(polDetailRendementNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.identitaetserkl) {
        const identItem: Navitem = {
          name:      'Identitätserklärung',
          routerUrl: '/polizze/' + police.id.toString() + '/ident'
        };
        // Insert Ident after Uebersicht item
        navItems.splice(1, 0, identItem);
      }
      if (police.tabs && police.tabs.produktionsblatt) {
        const provIdx = navItems.findIndex(itm => itm.name === 'Provisionen');
        const provItem: Navitem = {
          name:      'Provisions und Produktionsblatt',
          routerUrl: '/polizze/' + police.id.toString() + '/produktionsblatt'
        };
        // Insert after Provisionen
        if (provIdx !== -1) {
          navItems.splice(provIdx + 1, 0, provItem);
        } else {
          navItems.push(
            provItem
          );
        }
      }
      if (police.tabs && police.tabs.gemeldeteZahlungen) {
        const buchungenIdx = navItems.findIndex(itm => itm.name === 'Buchungen/Inkasso');
        const gemZahlungenItem: Navitem = {
          name:      'Gemeldete Zahlungen',
          routerUrl: '/polizze/' + police.id.toString() + '/gemzahlungen'
        };
        // Insert after Buchungen
        if (buchungenIdx !== -1) {
          navItems.splice(buchungenIdx + 1, 0, gemZahlungenItem);
        } else {
          navItems.push(
            gemZahlungenItem
          );
        }
      }
      if (police.tabs && police.tabs.lebenKontofuehrung) {
        additonalItems.push(polDetailLebentNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.cocheck) {
        additonalItems.push({
          name:      'CoCheck',
          routerUrl: '/polizze/' + police.id.toString() + '/cocheck'
        });
      }
      if (police.tabs && police.tabs.zis) {
        additonalItems.push({
          name:      'ZIS',
          routerUrl: '/polizze/' + police.id.toString() + '/zis'
        });
      }
      if (police.tabs && police.tabs.apol) {
        additonalItems.push({
          name:      'Apol Log',
          routerUrl: '/polizze/' + police.id.toString() + '/apol'
        });
      }
      if (police.tabs && police.tabs.freischaden) {
        additonalItems.push({
          name:      'Freischaden',
          routerUrl: '/polizze/' + police.id.toString() + '/freischaden'
        });
      }
      if (police.tabs && police.tabs.genehmigungen) {
        additonalItems.push(polDetailGenehmigungenNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.rabattKonto) {
        additonalItems.push(polDetailRabattkontoNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.fondPlus) {
        additonalItems.push(polFondPlusNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.dfz) {
        additonalItems.push(polDFZNavItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.familienpassxml) {
        additonalItems.push(polFamilienpassItem('/polizze/' + police.id.toString()));
      }
      if (police.tabs && police.tabs.gutachten) {
        additonalItems.push({
          name:      'Gutachten',
          routerUrl: '/polizze/' + police.id.toString() + '/gutachten'
        });
      }
      if (police.tabs && police.tabs.mahnhistorie) {
        additonalItems.push({
          name:      'Mahnhistorie',
          routerUrl: '/polizze/' + police.id.toString() + '/mahnhistorie'
        });
      }
    }

    if (additonalItems.length > 0) {
      return [
        {
          subItems: [
            ...navItems,
            ...additonalItems
          ]
        }
      ];
    } else {
      return [{subItems: navItems}];
    }
  }

  public static getVertragSideNav(currentVertrag: Vertrag): SubItemCategory[] {
    const navItems = vertragNavItems('/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id);
    const additonalItems: Navitem[] = [];
    if (currentVertrag.anpassung) {
      additonalItems.push({
        name:      'Anpassung',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/anpassung'
      });
    }
    if (currentVertrag.nebenversicherung) {
      additonalItems.push({
        name:      'Nebenversicherung',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/nebenversicherung'
      });
    }
    if (currentVertrag.vinkulierung) {
      additonalItems.push({
        name:      'Vinkulierung',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/vinkulierung'
      });
    }
    if (currentVertrag.rueckversicherung) {
      additonalItems.push({
        name:      'Rückversicherung',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/rueckversicherung'
      });
    }
    if (currentVertrag.fremdeFuehrung) {
      additonalItems.push({
        name:      'Fremde Führung',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/fremde-fuehrung'
      });
    }
    if (currentVertrag.zusaetzlicheTexte) {
      additonalItems.push({
        name:      'Texte',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/texte'
      });
    }
    if (currentVertrag.rueckkaufswerte) {
      additonalItems.push({
        name:      'Rückkaufswerte',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/rueckkaufswerte'
      });
    }
    if (currentVertrag.showSelbstbehalt) {
      additonalItems.push({
        name:      'Selbstbehalt',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/selbstbehalt'
      });
    }
    if (currentVertrag.beteiligung) {
      additonalItems.push({
        name:      'Beteiligung',
        routerUrl: '/polizze/' + currentVertrag.polizzeId + '/vertrag/' + currentVertrag.id + '/beteiligung'
      });
    }
    const header: Navitem = {
      name:      'Zurück zur Polizze',
      routerUrl: '/polizze/' + currentVertrag.polizzeId,
      icon:      'arrow_back'
    };
    if (additonalItems.length > 0) {
      return [
        {
          clickableHeader: header,
          subItems:        [
            ...navItems,
            ...additonalItems
          ]
        }
      ];
    } else {
      return [
        {
          clickableHeader: header,
          subItems:        navItems
        }
      ];
    }
  }

  public static getPositionSideNav(currentPosition: Position): SubItemCategory[] {
    const navItems = positionsNavItems('/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id);
    const additonalItems: Navitem[] = [];
    if (currentPosition.zusaetzlicheTexte) {
      additonalItems.push({
        name:      'Texte/BVB',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/texte'
      });
    }
    if (currentPosition.vorpositionsdaten) {
      additonalItems.push({
        name:      'Vorpositionsdaten',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/vorposition'
      });
    }
    if (currentPosition.showPrognoseList) {
      additonalItems.push({
        name:      'Prognose',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/prognose'
      });
    }
    if (currentPosition.showGewinnPrognoseList) {
      additonalItems.push({
        name:      'Gewinnprognose',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/gewinnprognose'
      });
    }
    if (currentPosition.showPositionVeranlagungList) {
      additonalItems.push({
        name:      'Veranlagung',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/veranlagung'
      });
    }
    if (currentPosition.showZuzahlungTeilentnahmeList) {
      additonalItems.push({
        name:      'Zuzahlungen und Teilentnahmen',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/zuzahlungenteilentnahmen'
      });
    }
    if (currentPosition.showBilanz) {
      additonalItems.push({
        name:      'Bilanz',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/bilanz'
      });
    }
    if (currentPosition.showFonds) {
      additonalItems.push({
        name:      'Fondsdaten',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/fonds'
      });
    }
    if (currentPosition.showRentenkontoList) {
      additonalItems.push({
        name:      'Rentenkonto',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/rentenkonto'
      });
    }
    if (currentPosition.showGewinnkontoList) {
      additonalItems.push({
        name:      'Gewinnkonto',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/gewinnkonto'
      });
    }
    if (currentPosition.showLebenkontoList) {
      additonalItems.push({
        name:      'Lebenkonto',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/lebenkonto'
      });
    }
    if (currentPosition.selbstbehalt) {
      additonalItems.push({
        name:      'Selbstbehalt',
        routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId + '/position/' + currentPosition.id + '/selbstbehalt'
      });
    }
    const header: Navitem = {
      name:      'Zurück zum Vertrag',
      routerUrl: '/polizze/' + currentPosition.polizzeId + '/vertrag/' + currentPosition.vertragId,
      icon:      'arrow_back'
    };
    if (additonalItems.length > 0) {
      return [
        {
          clickableHeader: header,
          subItems:        [
            ...navItems,
            ...additonalItems
          ]
        }
      ];
    } else {
      return [
        {
          clickableHeader: header,
          subItems:        navItems
        }
      ];
    }
  }

  public static getZahlungSidenav(polizzeId: number, zahlungId: number): SubItemCategory[] {
    const navItems = zahlungsNavItems('/polizze/' + polizzeId + '/zahlung/' + zahlungId);
    const header: Navitem = {
      name:      'Zurück zur Polizze',
      routerUrl: '/polizze/' + polizzeId + '/buchungen',
      icon:      'arrow_back'
    };
    return [
      {
        clickableHeader: header,
        subItems:        navItems
      }
    ];
  }

  public static getPolizzebuchungSidenav(buchung: PolizzeBuchungDetail, polizzeId: number): SubItemCategory[] {
    const navItems = buchungsNavItems('/polizze/' + polizzeId + '/buchung/' + (buchung ? buchung.result.id : 'error'));
    const additonalItems: Navitem[] = [];
    if (buchung && buchung.vertragsbuchungen && buchung.vertragsbuchungen.length > 0) {
      if (buchung.vertragsbuchungen.findIndex(b => b.rueckversicherungsBuchung && b.rueckversicherungsBuchung.length > 0) !== -1) {
        additonalItems.push({
          name:      'Rückversicherung',
          routerUrl: '/polizze/' + polizzeId + '/buchung/' + (buchung ? buchung.result.id : 'error') + '/rueckvers'
        });
      }
      if (buchung.vertragsbuchungen.findIndex(b => b.beteiligungsBuchung && b.beteiligungsBuchung.length > 0) !== -1) {
        additonalItems.push({
          name:      'Beteiligung',
          routerUrl: '/polizze/' + polizzeId + '/buchung/' + (buchung ? buchung.result.id : 'error') + '/beteiligung'
        });
      }
      if (buchung.vertragsbuchungen.findIndex(b => b.vertreterbuchung && b.vertreterbuchung.length > 0) !== -1) {
        additonalItems.push({
          name:      'Vertreter',
          routerUrl: '/polizze/' + polizzeId + '/buchung/' + (buchung ? buchung.result.id : 'error') + '/vertreter'
        });
      }
    }
    const header: Navitem = {
      name:      'Zurück zur Polizze',
      routerUrl: '/polizze/' + polizzeId + '/buchungen',
      icon:      'arrow_back'
    };
    if (additonalItems.length > 0) {
      return [
        {
          clickableHeader: header,
          subItems:        [
            ...navItems,
            ...additonalItems
          ]
        }
      ];
    } else {
      return [
        {
          clickableHeader: header,
          subItems:        navItems
        }
      ];
    }
  }

  public static getPersonSideNav(person: Person, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/person/' + person.id + '/version/' + version;
    } else {
      urlpart = '/person/' + person.id;
    }
    let navItems = personDetailNavItems(urlpart);
    if (person.locked) {
      navItems = [personDetailLocked(urlpart)];
    } else {
      if (person.tabs) {
        if (person.tabs.verbund) {
          const ksIdx = navItems.findIndex(itm => itm.name === 'Kundensegment');
          const verbundItem: Navitem = {
            name:      'Verbundebene',
            routerUrl: urlpart + '/kundenverbund'
          };
          if (ksIdx !== -1) {
            navItems.splice(ksIdx + 1, 0, verbundItem);
          } else {
            navItems.push(
              verbundItem
            );
          }
        }
        if (person.tabs.grosskundenkonto) {
          const uebersichtIdx = navItems.findIndex(itm => itm.name === 'Personendaten');
          const gkItem: Navitem = {
            name:      'Großkundenkonto',
            routerUrl: urlpart + '/grosskunde'
          };
          if (uebersichtIdx !== -1) {
            navItems.splice(uebersichtIdx + 1, 0, gkItem);
          } else {
            navItems.push(
              gkItem
            );
          }
        }
        if (person.tabs.lebenDaten) {
          navItems.push(
            {
              name:      'Leben-Daten',
              routerUrl: urlpart + '/leben-daten'
            }
          );
        }
        if (person.tabs.termine) {
          navItems.push(
            {
              name:      'Termine',
              routerUrl: urlpart + '/termine'
            }
          );
        }
        if (person.tabs.grosskundenbriefe) {
          navItems.push(
            {
              name:      'Briefe',
              routerUrl: urlpart + '/briefe'
            }
          );
        }
        if (person.tabs.risikoklassifizierung) {
          navItems.push(
            {
              name:      'Geldwäsche',
              routerUrl: urlpart + '/geldwaesche'
            }
          );
        }
        if (person.tabs.bezugspersonen) {
          navItems.push(
            {
              name:      'Weitere Personen',
              routerUrl: urlpart + '/weitere'
            }
          );
        }
        if (person.tabs.gesundheitsFragebogen) {
          navItems.push(
            {
              name:      'Fragebögen',
              routerUrl: urlpart + '/gesundheitsfragebogen'
            }
          );
        }
        if (person.tabs.risikokapital) {
          navItems.push(
            {
              name:      'Risikoübersicht LV',
              routerUrl: urlpart + '/risikouebersichtlv'
            }
          );
        }
      }
    }

    return [{subItems: navItems}];
  }

  public static getVertreterSideNav(vertreter: Vertreter, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/vertreter/' + vertreter.person.id + '/version/' + version;
    } else {
      urlpart = '/vertreter/' + vertreter.person.id;
    }
    const navItems = vertreterDetailNavItems(vertreter, urlpart);
    if (vertreter.showBankdaten) {
      navItems.push({
        name:      'Bank',
        routerUrl: urlpart + '/bankverbindung'
      });
    }
    if (vertreter.showOMDS) {
      navItems.push({
        name:      'OMDS',
        routerUrl: urlpart + '/omds'
      });
    }
    return [{subItems: navItems}];
  }

  public static getHotlineSideNav(personId: string): SubItemCategory[] {
    return [{subItems: hotlineDetailNavItems('/hotline/' + personId)}];
  }

  public static getBetreuerknotenSidenav(betreuer: Betreuer): SubItemCategory[] {
    return [{subItems: betreuerknotenDetailNavItems('/maklerknoten/' + betreuer.person.id, betreuer)}];
  }

  public static getTexteSidenav(baustein: Textbaustein): SubItemCategory[] {
    return [{subItems: textDetailNavItems('/texte/' + baustein.txtId + '/art/' + baustein.art + '/sprache/' + baustein.sprache)}];
  }

  public static getFamilienpassSidenav(person: Person): SubItemCategory[] {
    return [{subItems: familienpassDetailNavItems('/familienpass/' + person.id)}];
  }

  public static getMaklerFamilienpassSidenav(person: Person): SubItemCategory[] {
    return [{subItems: familienpassDetailNavItems('/maklerfamilienpass/' + person.id)}];
  }

  public static getPartnerSidenav(person: Person, version: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/partner/' + person.id + '/version/' + version;
    } else {
      urlpart = '/partner/' + person.id;
    }
    return [{subItems: partnerDetailNavItems(urlpart)}];
  }

  public static getSchadenzahlungempfSidenav(person: Person): SubItemCategory[] {
    return [{subItems: schadenzahlungempfDetailNavItems('/schadenzahlungempf/' + person.id)}];
  }

  public static getSchadenbeteiligterSidenav(nav: string): SubItemCategory[] {
    return [
      {
        subItems: schadenbeteiligterDetailNavItems(nav)
      }
    ];
  }

  public static getZulassungSidenav(zulassung: ZulassungResult): SubItemCategory[] {
    return [{subItems: zulassungDetailNavItems('/zulassung/' + zulassung.zulId + '/index/' + zulassung.index)}];
  }

  public static getBezugsberechtigterSidenav(personId: number, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/bezugsberechtigter/' + personId + '/version/' + version;
    } else {
      urlpart = '/bezugsberechtigter/' + personId;
    }
    return [{subItems: bezugsberechtigterDetailNavItems(urlpart)}];
  }

  public static getAssistancePolizzeSideNav(personId: number, polizzenId: number): SubItemCategory[] {
    const additonalItems: Navitem[] = [];
    if (polizzenId) {
      additonalItems.push({
        name:      'Polizzendetails',
        routerUrl: '/assistance/' + personId + '/polizze/' + polizzenId
      });
    }
    const header: Navitem = {
      name:      'Zurück zur Person',
      routerUrl: '/assistance/' + personId,
      icon:      'arrow_back'
    };
    if (additonalItems.length > 0) {
      return [
        {
          clickableHeader: header,
          subItems:        [
            ...additonalItems
          ]
        }
      ];
    }
  }

  public static getAssistanceSideNav(personId: string): SubItemCategory[] {
    const navItems = assistanceDetailNavItems('/assistance/' + personId);
    const additonalItems: Navitem[] = [];
    if (additonalItems.length > 0) {
      return [
        {
          subItems: [
            ...navItems,
            ...additonalItems
          ]
        }
      ];
    } else {
      return [
        {
          subItems: navItems
        }
      ];
    }
  }

  public static getSchadenSideNav(schaden: Schaden): SubItemCategory[] {
    const urlPart = '/schaden/' + schaden.id;
    let navItems = schadenDetailNavItems(urlPart);
    if (schaden.tabs && schaden.tabs.beschreibendeDaten) {
      const zlIdx = navItems.findIndex(itm => itm.name === 'Zahlungen');
      const beschrItem: Navitem = {
        name:      'Beschr. Daten',
        routerUrl: urlPart + '/beschrdaten'
      };
      if (zlIdx !== -1) {
        navItems.splice(zlIdx + 1, 0, beschrItem);
      } else {
        navItems.push(
          beschrItem
        );
      }
    }
    const additonalItems: Navitem[] = [];
    if (schaden.locked) {
      navItems = [];
      additonalItems.push(schadenDetailLocked('/schaden/' + schaden.id));
    } else {
      if (schaden.deckungsBedenken && schaden.deckungsBedenken.length > 0) {
        additonalItems.push(schadenDeckungsbedenken('/schaden/' + schaden.id));
      }
    }
    if (additonalItems.length > 0) {
      return [
        {
          subItems: [
            ...navItems,
            ...additonalItems
          ]
        }
      ];
    } else {
      return [{subItems: navItems}];
    }
  }

  public static getFahrzeugSideNav(fahrzeugId: string, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/fahrzeug/' + fahrzeugId + '/version/' + version;
    } else {
      urlpart = '/fahrzeug/' + fahrzeugId;
    }
    return [{subItems: fahrzeugDetailNavItems(urlpart)}];
  }

  public static getHaushaltSideNav(adresseId: string): SubItemCategory[] {
    return [{subItems: haushaltDetailNavItems('/haushalt/' + adresseId)}];
  }

  public static getGebaeudeSideNav(id: string, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/gebaeude/' + id + '/version/' + version;
    } else {
      urlpart = '/gebaeude/' + id;
    }
    return [{subItems: gebaeudeDetailNavItems(urlpart)}];
  }

  public static getVsbSideNav(id: string): SubItemCategory[] {
    return [{subItems: vsbDetailNavItems('/vsb/' + id)}];
  }

  public static getVerbundSideNav(id: string): SubItemCategory[] {
    return [{subItems: verbundDetailNavItems('/verbund/' + id)}];
  }

  public static getBetreuerSidenav(betreuer: Betreuer, version?: string): SubItemCategory[] {
    return [{subItems: betreuerDetailNavItems(betreuer, version)}];
  }

  public static getMaklerpersonSidenav(person: Person): SubItemCategory[] {
    return [{subItems: maklerpersonDetailNavItems('/maklerperson/' + person.id)}];
  }

  public static getMaklerpolizzeSidenav(polizze: Polizze): SubItemCategory[] {
    const additonalItems: Navitem[] = [];
    let navItems: Navitem[] = [];
    if (polizze.locked) {
      additonalItems.push(polDetailLocked('/maklerpolizze/' + polizze.id));
    } else {
      navItems = maklerpolizzeDetailNavItems('/maklerpolizze/' + polizze.id);
      if (polizze.tabs.zusaetzlicheTexte) {
        additonalItems.push({
          name:      'Besondere Vereinbarungen',
          routerUrl: '/maklerpolizze/' + polizze.id + '/vereinbarungen'
        });
      }
    }
    return [
      {
        subItems: [
          ...navItems,
          ...additonalItems
        ]
      }
    ];
  }

  public static getMaklerschadenSidenav(schaden: Schaden): SubItemCategory[] {
    return [{subItems: maklerschadenDetailNavItems('/maklerschaden/' + schaden.id)}];
  }

  public static getMaklerDLSidenav(): SubItemCategory[] {
    return [{subItems: maklerDLNavItems('/maklerdocuments')}];
  }

  public static getCMSSidenav(): SubItemCategory[] {
    return [{subItems: cmsNavItems('/cms')}];
  }

  public static getZulassungKennzeichenSidenav(kennzeichen: string): SubItemCategory[] {
    return [{subItems: zulassungKennzeichenNavItems('/zulassung/kennzeichen/' + kennzeichen)}];
  }

  public static getUngeklaerteZahlungenArchivSidenav(zahlung: PolizzeOpostenArchivUngeklaerteZahlungen): SubItemCategory[] {
    return [{subItems: ungeklaerteZahlungenArchivDetailNavItems('/ungeklaertezahlungen/archiv/' + zahlung.ungeklaerteZahlung.id)}];
  }

  public static getBetreuerdatenAdminSidenav(): SubItemCategory[] {
    return [{subItems: betreuerdatenadminNavItems('/betreuerdatenadmin')}];
  }

  public static getReferatAdminSidenav(): SubItemCategory[] {
    return [{subItems: referatAdminNavItems('/referatadmin')}];
  }

  public static getMaklervertreterSidenav(vertreter: Vertreter): SubItemCategory[] {
    const navItems = maklervertreterDetailNavItems('/maklervertreter/' + vertreter.person.id);
    const additonalItems: Navitem[] = [];
    if (vertreter.showProvision) {
      additonalItems.push(
        {
          name:      'Buchungsbriefe',
          routerUrl: `/maklervertreter/${vertreter.person.id}/bbr`
        },
        {
          name:      'Buchungen',
          routerUrl: '/maklervertreter/' + vertreter.person.id + '/buchungen'
        });
    }
    return [
      {
        subItems: [
          ...navItems,
          ...additonalItems
        ]
      }
    ];
  }

  public static getBeitragszahlerSidenav(person: Person, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/beitragszahler/' + person.id + '/version/' + version;
    } else {
      urlpart = '/beitragszahler/' + person.id;
    }
    return [{subItems: beitragszahlerDetailNavItems(urlpart)}];
  }

  public static getVersichertepersonsidenav(person: Person, version?: string): SubItemCategory[] {
    let urlpart: string;
    if (version && version !== '1') {
      urlpart = '/versicherteperson/' + person.id + '/version/' + version;
    } else {
      urlpart = '/versicherteperson/' + person.id;
    }
    let navItems = versichertepersonDetailNavItems(urlpart);
    if (person.tabs.gesundheitsFragebogen) {
      navItems.push(
        {
          name:      'Fragebögen',
          routerUrl: urlpart + '/gesundheitsfragebogen'
        }
      );
    }
    return [{subItems: navItems}];
  }

  public static getUserAdminSideNav(id: string): SubItemCategory[] {
    let urlpart: string;
    urlpart = '/benutzer/' + id;

    let navItems = userAdminDetailNavItems(urlpart);

    return [{subItems: navItems}];
  }
  public static getKundenAdminSideNav(id: string): SubItemCategory[] {
    let urlpart: string;
    urlpart = '/kundendatenadmin';

    let navItems = kundenAdminNavItems(urlpart, id);

    return [{subItems: navItems}];
  }
}
